// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const accordionClasses = {
  icon: "qui-accordion__icon",
  item: "qui-accordion__item",
  itemContentAnimator: "qui-accordion__item-content-animator",
  itemContentBody: "qui-accordion__item-content-body",
  itemText: "qui-accordion__item-text",
  itemTrigger: "qui-accordion__item-trigger",
  itemTriggerIndicator: "qui-accordion__item-trigger-indicator",
  itemTriggerSecondary: "qui-accordion__item-trigger-secondary",
  root: "qui-accordion__root",
} as const
